import React from 'react';
import { Icon } from '../Icon/Icon';
import { classNames } from '../../utilities';
import '../../base.scss';
import './SortIcon.scss';

export interface SortIconProps {
  direction?: 'up' | 'down';
}

export function SortIcon(props: SortIconProps) {
  const { direction } = props;

  const upArrowClasses = classNames(
    'ps-sort-icon__arrow',
    'ps-sort-icon__arrow--up',
    direction === 'up' ? 'ps-sort-icon__arrow--dark' : ''
  );

  const downArrowClasses = classNames(
    'ps-sort-icon__arrow',
    'ps-sort-icon__arrow--down',
    direction === 'down' ? 'ps-sort-icon__arrow--dark' : ''
  );

  return (
    <div className="ps-sort-icon">
      <Icon name='SortUp' className={upArrowClasses}/>
      <Icon name='SortDown' className={downArrowClasses}/>
    </div>
  );
}
